import * as Swiper from 'swiper/js/swiper.js';

export default class initTestSlider{
    constructor() {
        this.slider = document.querySelectorAll('.js-hp-slider-testimonials');
        if (this.slider === null) return;

        Array.prototype.forEach.call(this.slider, (slider) => {
            this.initSlider(slider);
        });
    }

    initSlider(slider) {
        let btnNext = slider.querySelector('.test-swiper-button-next');
        let btnPrev = slider.querySelector('.test-swiper-button-prev');
        new Swiper(slider, {
            effect: 'fade',
            pagination: false,
            slidesPerView: 1,
            direction: 'horizontal',
            speed: 500,
            loop: true,
            navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
            }
        });
    }
}